import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';

export const TitleStyles = styled(OnboardingTitle)`
  .ion-page & {
    margin: 24px auto 16px;
  }
`;

export const SubtitleStyles = styled(UiTypography)`
  text-align: center;
  margin: 0 16px;
`;

export const AnimationContainer = styled.div`
  margin: 40px 16px 0;
`;
